import React from "react";
import AuditorReport from "../AdminPortal/AuditorReport";

const DMAuditorReport = () => {
  return <AuditorReport />;
};

export default DMAuditorReport;
